import icon from '~/assets/public/xero-icon.png';
import { Tooltip } from '~/components';
import { useIntegrations } from '~/contexts';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
  cursor: pointer;
`;

const Image = styled.img`
  width: 1rem;
  height: 1rem;
`;

export default function XeroIndicator({ message = 'This credit note is in Xero.', xeroCreditNoteId }) {
  const integrations = useIntegrations();
  if (!integrations.xero) return null;

  const handleClick = (event) => {
    event.stopPropagation();

    if (xeroCreditNoteId) {
      const creditNoteURL = integrations.xero.orgCode
        ? `https://go.xero.com/organisationlogin/default.aspx?shortcode=${integrations.xero.orgCode}&redirecturl=/AccountsReceivable/ViewCreditNote.aspx?creditNoteID=${xeroCreditNoteId}`
        : `https://go.xero.com/AccountsReceivable/ViewCreditNote.aspx?creditNoteID=${xeroCreditNoteId}`;
      return window.open(creditNoteURL, '_blank');
    }
  };

  return (
    <Wrapper onClick={handleClick}>
      <Tooltip message={message}>
        <Image src={icon} />
      </Tooltip>
    </Wrapper>
  );
}
